//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      book: {},
      value: '',
      percent2: 0,
      studyInfo: {},
      checkinStatus: {},
      reviewCount: {},
      todayStats: {},
      cpDaily: {}
    }
  },
  computed: {
    quickNav () {
      return [
        { key: 'review', label: '智能复习', icon: 'replay', color: '#6c5ce7', bg: '#f3f0ff', badge: this.reviewCount.total_count || '', action: this.goReviewPractice },
        { key: 'search', label: '单词搜索', icon: 'search', color: '#00b894', bg: '#e8faf5', action: this.searchWord },
        { key: 'stats', label: '学习数据', icon: 'chart-trending-o', color: '#4a90e2', bg: '#eef5ff', action: this.goStats },
        { key: 'palace', label: '记忆宫殿', icon: 'home-o', color: '#1E3A5F', bg: '#e8eef5', action: () => this.$router.push({ path: '/mpHome_display', query: { from: 'home' } }) }
      ]
    }
  },
  created () {
    this.getUserBook()
    this.loadNewModuleData()
  },
  activated () {
    this.getUserBook()
  },
  methods: {
    loadNewModuleData () {
      this.$ajax.get(this.$api.checkinStatus).then(res => { this.checkinStatus = res || {} }).catch(() => {})
      let reviewUrl = this.$api.reviewTodayCount
      if (this.book.categoryId) reviewUrl += '?category_id=' + this.book.categoryId
      this.$ajax.get(reviewUrl).then(res => { this.reviewCount = res || {} }).catch(() => {})
      this.$ajax.get(this.$api.statsToday).then(res => { this.todayStats = res || {} }).catch(() => {})
      this.$ajax.get(this.$api.cpSceneDaily).then(res => { this.cpDaily = res || {} }).catch(() => {})
    },
    doCheckin () {
      this.$ajax.post(this.$api.checkinDo, {}).then(res => {
        if (res && res.success) {
          this.$toast(res.message || '打卡成功')
          this.loadNewModuleData()
        } else {
          this.$toast((res && res.message) || '打卡失败')
        }
      })
    },
    goCheckin () { this.$router.push('/checkinCalendar_display') },
    goReviewPractice () {
      this.$router.push({
        path: '/reviewHome_display',
        query: { categoryId: this.book.categoryId, from: 'home' }
      })
    },
    goStats () { this.$router.push('/statsHome_display') },
    getStudyInfo (categoryId) {
      if (!categoryId) return
      this.$ajax.get(this.$api.getStudyInfo + '?pkId=' + categoryId).then(response => {
        this.studyInfo = response || {}
        const size = Number(response.size) || 0
        const wordSize = Number(response.wordSize) || 0
        this.studyInfo.proportion = size > 0 ? Math.min(100, Math.ceil(wordSize * 100 / size)) : 0
        this.percent2 = this.studyInfo.proportion
      })
    },
    getUserBook () {
      this.$ajax.post(this.$api.getUserInfo, { key: 'studyBookID' }).then(result => {
        this.book = result || {}
        if (result && result.categoryId) {
          this.getStudyInfo(result.categoryId)
          this.loadNewModuleData()
        }
      })
    },
    showwordIndex () {
      this.$router.push({ path: '/wordIndex_displa', query: { selectBook: 1 } })
    },
    showDetail () {
      if (!this.book.categoryId) {
        this.$toast('当前未添加学习书籍')
        return
      }
      this.$router.push({
        path: '/pmsCellList_display',
        query: { value: this.book.categoryId, label: this.book.categoryName, source: 'home' }
      })
    },
    searchWord () {
      const query = { hideTrans: 'true' }
      if (this.value && this.value.trim()) query.keyword = this.value.trim()
      this.$router.push({ path: '/wordSearch_display', query })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/publicView/Home.vue